import type { FaireProductEntity } from "../../entity_types/product";

export const p_5964gt9sjb: FaireProductEntity = {
  token: "p_5964gt9sjb",
  type: "product",
  name: "18K Gold Plated Waterproof Stainless Steel Chain Necklace - 7812",
  brandToken: "b_4zc36e4kj9",
  brandName: "Mia Accessories",
  imageUrl:
    "https://cdn.faire.com/fastly/d6520f8a9b564e1fec01031c498ed46c27fc9d8fa3b5eabbcf55750dc47a200d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/98da3a5599137205b12ba32c19f6d91d73ed0e8e732da2579a134b3509234802.jpeg",
    "https://cdn.faire.com/fastly/8f6a48980ee78208ce9bd194e1569cf04f3d7adad320ade151286f1b9008af9b.jpeg",
  ],
  priceDollars: 9.63,
  description:
    'Dainty 18K Gold Plated Stainless Steel Chain Layered Cross Necklace.\nShortest layer is 14.5" L + 2" extender.\n\n\n\n\nThis item is hypoallergenic, waterproof and tarnish-resistant.\n\n*To prolong the shine and finish of the gold plating, contact with chemicals such as lotions, perfumes, and cleaning products should be avoided.*\n\n\n',
  tags: [],
  msrpDollars: 38.52,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:54:59.641Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
